import Vue from 'vue'
import axios from 'axios';
import $ from 'jquery'
import Router from 'vue-router'
// import { component } from 'vue/types/umd'
const Index = () => import('@/page/Index')
const Login = () => import('@/page/Login')
const headNav = () => import('@/components/headNav')
const workbench = () => import('@/page/workbench') //工作台
const bookedRecord = () => import('@/page/bookedRecord') //约访记录
const later = () => import('@/page/later') //约访记录
const specimen = () => import('@/page/specimen') //约访记录
const statistics = () => import('@/page/statistics') //样本记录
const sampleTable = () => import('@/page/sampleTable') //样本表格
Vue.use(Router)

// 重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

const router = new Router({
	//mode: 'history',
	//base:"/wjgui/",
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [
		{
			path: '/',
			name: 'Index',
			component: Index,
			redirect: '/workbench',
			children: [
				{
					path: '/workbench',
					name: 'workbench',
					component: workbench
				},
				{
					path: '/bookedRecord',
					name: 'bookedRecord',
					component: bookedRecord,
				},
				{
					path: '/later',
					name: 'later',
					component: later
				},
				{
					path: '/specimen',
					name: 'specimen',
					component: specimen
				}
			]
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
		}
	]
})
router.beforeEach((to, form, next) => {

	//判断跳转的登录页面
	if (window.ssoswitch == "on") {
		if (to.path == "/login") {
			window.location.href = VUE_APP_CAS_BASE_URL + "/login?service=" + VUE_APP_CAS_BACKSERVICE_URL
		} else {
			if (!localStorage.getItem('token')) {
				let ticket = getQueryString("ticket");
				if (ticket != null) {
					caslogin(ticket, to, form, next);
				}
			}
		}
	}
	if (to.matched.some(res => res.meta.requireAuth)) {
		if (localStorage.getItem('token')) {
			next()
		} else {
			console.log(';;;;;;;;;;;;;;;;;;;;;;;;;;;;;', to.fullPath)
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		next()
	}
})
async function caslogin(ticket, to, form, next) {
	$.ajax({
		//请求方式
		type: "GET",
		async: false,
		//请求的媒体类型
		contentType: "application/json;charset=UTF-8",
		//请求地址
		url: window.global_host + "/api/v1/sso/caslogin?ticket=" + ticket,
		//数据，json字符串
		//data : JSON.stringify(list),
		//请求成功
		success: function(result) {
			if (result.code == 0) {
				let userInfo = JSON.stringify(result.resultBody);
				window.localStorage.setItem('userInfo', userInfo);
				window.localStorage.setItem('token', result.resultBody.token);
			} else if (result.code == 1001) {
				window.location.href = VUE_APP_CAS_BASE_URL + "/login?service=" +
					VUE_APP_CAS_BACKSERVICE_URL
			}
		},
		//请求失败，包含具体的错误信息
		error: function(e) {
			console.log(error);
		}
	});

	/*await axios({
		method: 'GET',
		url: window.global_host+"/api/v1/sso/caslogin?ticket="+ticket,
	})
		.then(response => {
			if (response.data.code == 0) {
				let userInfo = JSON.stringify(response.data.resultBody);
				window.localStorage.setItem('userInfo', userInfo);
				window.localStorage.setItem('token', response.data.resultBody.token);
			} else if (res.code == 1001) {
				window.location.href = VUE_APP_CAS_BASE_URL + "/login?service=" + VUE_APP_CAS_BACKSERVICE_URL
			}
		})
		.catch(error => {
			console.log(error);
		});*/
}

function getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}
export default router;
